import React, { useState } from 'react';

import Button from '~components/Button';
import Icon, { faLink } from '~components/icon';
import Modal from '~components/Modal';
import { Form as WizardForm } from '~components/wizard-form';

import bulkSahAssignFields from '~support-at-home/forms/budgets/bulkSahAssign';

interface ComponentProps {
  canUpdate: boolean;
  selectedIds: string[];
  onComplete: () => void;
}

const BulkSahAssignWizard: React.FC<ComponentProps> = ({ canUpdate, selectedIds, onComplete }) => {
  const [isOpen, setIsOpen] = useState(false);

  // Called only when the wizard reaches the final step and the user clicks "Close" — triggers the
  // parent refetch and selection-clear. Dismissing the modal mid-flow (X button / backdrop) must
  // NOT call onComplete so the row selection is preserved.
  const handleWizardComplete = () => {
    setIsOpen(false);
    onComplete();
  };

  if (!canUpdate) return null;

  return (
    <div className="d-flex align-items-center me-2">
      <Button
        id="budgets-bulk-sah-assign-button"
        data-cy="budgets-bulk-sah-assign-button"
        size="sm"
        disabled={selectedIds.length === 0}
        onClick={() => setIsOpen(true)}
      >
        <Icon className="me-2" icon={faLink} />
        Assign SAH Budgets
      </Button>
      <Modal
        size="xl"
        style={{ maxWidth: '1500px', width: '100%' }}
        isOpen={isOpen}
        setIsOpen={setIsOpen}
        onClose={() => setIsOpen(false)}
        headerClassName="header"
        header="Bulk SAH Budget Assignment"
        className="budgets-bulk-sah-assign-wizard-modal"
        includeFooter={false}
        unmountOnClose
      >
        <WizardForm
          steps={bulkSahAssignFields}
          initialValues={{ budget_ids: selectedIds, assignments: undefined }}
          onComplete={handleWizardComplete}
          submitCaption="Close"
        />
      </Modal>
    </div>
  );
};

export default BulkSahAssignWizard;
